import React from "react";
import PropTypes from "prop-types";
import { useSession } from "context/SessionContext";

function Footer(props) {
  const { session } = useSession();

  const getSwaggerUrl = () => {
    return (
      "https://" +
      window.location.hostname +
      "/swagger-ui/index.html?urls.primaryName=V4"
    );
  };

  const getHelpUrl = () => {
    return (
      "https://" + window.location.hostname + "/help/VirtuosoUserGuide.html"
    );
  };

  const getCertificateUrl = () => {
    return "/auth/certificate";
  };

  const getAcknowledgementsUrl = () => {
    return "/admin/acknowledgements";
  };

  return (
    <footer className={"footer" + (props.default ? " footer-default" : "")}>
      {session.currentVersion ? "Virtuoso " + session.currentVersion : ""}
      {session.currentBuildNumber ? " #" + session.currentBuildNumber : ""}
      {session.currentVersion || session.currentBuildNumber ? " - " : ""}
      &copy; {1900 + new Date().getYear()} Positron Access Solutions, All rights
      reserved
      <br />
      <div style={{ marginTop: "10px" }}>
        <a target="_blank" href={getSwaggerUrl()}>
          API Docs
        </a>
        {session.user && (
          <a style={{ marginLeft: "15px" }} href={getAcknowledgementsUrl()}>
            Acknowledgements
          </a>
        )}
        <a style={{ marginLeft: "15px" }} href={getCertificateUrl()}>
          Client Certificate
        </a>
        <a style={{ marginLeft: "15px" }} target="_blank" href={getHelpUrl()}>
          Help
        </a>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
